function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39 39"
}, props), React.createElement("path", {
  d: "M19.504 39.002C30.259 39.002 39 30.255 39 19.506 39 8.756 30.26 0 19.504 0 8.748 0 0 8.75 0 19.499c0 10.748 8.748 19.503 19.504 19.503zM15.162 12.28c0-.91 1.009-1.448 1.77-.953l10.911 7.2a1.139 1.139 0 010 1.902L16.935 27.64c-.754.5-1.77-.044-1.77-.953l-.003-14.408z",
  fill: "#000"
})));